import React, { useState, useEffect } from 'react';
import { Route, Switch, useLocation, BrowserRouter as Router, useHistory } from 'react-router-dom';
import QueryString from 'query-string';
import Layout from './components/Layout';
import Home from './components/Home/Home';
import MCT from './components/Quoters/MCT/MCT';
import Americo from './components/Quoters/Americo/Americo';
import SecurianWL from './components/Quoters/Securian/WL/SecurianWL';
import LTC from './components/Quoters/LTC/LTC';
import Ineligible from './components/Quoters/Common/Ineligible';
import Ameritas from './components/Quoters/Ameritas/Ameritas';
import EsignReturn from './components/Quoters/Common/EsignReturn';
import BudgetBasedQuoter from './components/Tools/BudgetBasedQuoter/BudgetBasedQuoter';
import Theme from './components/Theme/Theme';
import ProductLandingPage from './components/LandingPages/ProductLandingPage';
import { ThemeProvider } from '@material-ui/core/styles';
import NewSession from './components/NewSession';
import { setBasicInfo, getSessionStorageItem, setSessionStorageItemWithExpiration, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_CLIENTINFO_KEY, setSessionStorageItem, SESSION_STORAGE_UTM_DATA, SESSION_STORAGE_UTM_REDIRECT_KEY, SESSION_STORAGE_EMAIL_CAPTURE, SESSION_STORAGE_SAVED_QUOTE_DATA, } from './sessionStorage';
import { retrieveAccount } from './account';
import { retrieveConsumer } from './purlConsumer';
import { loadClientInfo } from './clientInfo';
import { saveSessionEvent } from './session';
import StateDisclosure from './components/Disclosure/StateDisclosure';
import Status from './components/Status/Status';
import Portal from './components/Portal/Portal';
import DidNotConsent from './components/Quoters/Securian/WL/DidNotConsent';
import Products from './components/Helpers/Data/Products/Products';
import CircularProgress from '@material-ui/core/CircularProgress';
import RetrieveProgress from './components/General/RetrieveProgress';
import NoIeSupport from './components/Helpers/Errors/Templates/NoIeSupport';
import Medicare from './components/Quoters/Medicare/Medicare';
import Gerber from './components/Quoters/Forms/GerberForm';
import Supplemental from './components/Quoters/Supplemental/Supplemental';
import Account from './components/Account/Account';
import Landing from './components/PolicyReview/Landing';
import ExistingInsurance from './components/PolicyReview/ExistingInsurance';
import Schedule from './components/PolicyReview/Schedule';
import Summary from './components/PolicyReview/Summary';
import { detect } from 'detect-browser';
import Aflac from './components/Quoters/Aflac/Aflac';
import Digital from './components/Quoters/Digital/Digital';
import LongTerm from './components/Quoters/LongTerm/LongTerm';
import PartnerReferral from './components/PartnerReferral/PartnerReferral';
import CustomizeTerm from './components/Quoters/CustomizeTerm/CustomizeTerm';
import FinalExpense from './components/Quoters/FinalExpense/FinalExpense';
import WholeLife from './components/Quoters/WholeLife/WholeLife';
import UniversalLife from './components/Quoters/UniversalLife/UniversalLife';
import LoanProtection from './components/Quoters/AmericoLoanProtection/LoanProtection';
import AppointmentScheduler from './components/Scheduler/AppointmentScheduler';

const browser = detect();
var isIe = browser.name === 'ie';

const PageNotFound = () => {
  return (
    <div className="container">
      <div className="jumbotron mt-4">Page not found.</div>
    </div>
  );
};

let primaryColor = null;
let secondaryColor = null;

const setColorsFromAccount = (acc) => {
    primaryColor = acc ? acc.primaryColor : null;
    secondaryColor = acc ? acc.secondaryColor : null;
};

const parseUtm = (location) => {
  const queryString = QueryString.parse(location.search);
  return JSON.stringify(Object.entries(queryString)
    .filter(key => key[0].substring(0, 4) === "utm_").map(u => {
      return u.reduce((k, v) => {
        return { [k]: v };
      })
    }));
}

const App = () => {
  const [loadingSite, setLoadingSite] = useState(true);
  const [loadingClientInfo, setLoadingClientInfo] = useState(true);
  const [error, setError] = useState(false);
  
  const history = useHistory();

  let location = useLocation();

  const redirectUtm = (acc) => {
    if (acc.accountRedirects) {
      const redirects = acc.accountRedirects
        .filter(redr => redr.isEnabled)
        .reduce((obj, redr) => {
          obj[`${redr.utmKey}_${redr.utmValue}`] = redr.redirectUrl;
          return obj;
        }, {});
      const queryString = QueryString.parse(location.search);
      for (let key in queryString) {
        if (key.substring(0, 4).toLowerCase() === "utm_") {
          const queryStringUrl = `${key.substring(4)}_${queryString[key]}`.toLowerCase();
          const redirectUrl = redirects[queryStringUrl];
          if (redirectUrl) {
            history.push(redirectUrl);
          }
        }
      }
    }
  }

  const processPurl = (utm) => {

    const utmObj = JSON.parse(utm).find(g => g.utm_guid !== undefined);

    const purlRedirect = (productType) => {
      let redirect;

      switch(productType) {
        case "terma":
          redirect = "/term-insurance/quote-results";
          break;
        case "termb":
          redirect = "/quote/term-life-insurance/multi-carrier-term/get-a-quote";
          break;
        case "securianwl":
          redirect = "/quote/whole-life/securian-secure-promise/get-a-quote";
          break;
        case "securiancwl":
          redirect = "/quote/whole-life/securian-secure-promise/get-a-quote?juvi";
          break;
        case "loanprotector":
          redirect = "/loan-protection/quote-results";
          break;
        default:
          redirect = "/";
          break;
      };

      return redirect;
    };

    if (utmObj) {
      if (Object.keys(utmObj).length > 0) {
        setSessionStorageItem("ACTIVE_PURL", {"active": true});
      }

      retrieveConsumer(utmObj.utm_guid).then((consumer) => {
        const productType = !consumer.message ? consumer.productType.toLowerCase() : null;
        const redirectPath = purlRedirect(productType);
        const prefill = {
          firstName: "",
          lastName: "",
          gender: consumer.gender,
          birthdate: "",
          fakeBirthdate: consumer.fakeBirthDate,
          state: consumer.state,
          tobacco: productType && consumer.productType.toLowerCase() == "terma" ? "false" : "Never",
          email: "",
          phone: null,
          faceAmount: consumer.coverageAmount,
          termLength: isNaN(parseInt(consumer.termLength)) ? 30 : parseInt(consumer.termLength),
          healthClass: "PP",
          height: "",
          weight: "",
          bmi: null,
          income: null,
          preQuoteAbbreviatedQualified: null,
          preQuoteHealthClass: null,
          replacePolicy: null,
          usResident: true
        };
        
        setBasicInfo(prefill);

        history.push(redirectPath);
      });
    }
    else {
      setSessionStorageItem("ACTIVE_PURL", {"active": false});
    }
  };

  const setEmailCapture = (account) => {
    const emailCaptureObj = getSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE);
    setSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE, {
      ...emailCaptureObj,
      "enableInitialEmailCapture": account.enableInitialEmailCapture,
      "enableTimeoutEmailCapture": account.enableTimeoutEmailCapture,
    });
  }

  const setSaveQuoteData = () => {
    const savedQuoteObj = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);
    setSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA, {
      "quoteSaved": savedQuoteObj ? savedQuoteObj.quoteSaved : false,
      "emailAddress": savedQuoteObj ? savedQuoteObj.emailAddress : "",
      "firstName": savedQuoteObj ? savedQuoteObj.firstName : "",
    });
  };

  useEffect(() => {
    saveSessionEvent();
  }, [location]);

  useEffect(() => {
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const utmData = parseUtm(location);
    const utmArray = JSON.parse(utmData);
    if(utmArray.length > 0){
      const stringArray = utmArray.map(obj => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        return `${key}=${value}`;
      });
      const resultString = stringArray.join(', ');
      setSessionStorageItem(SESSION_STORAGE_UTM_DATA, resultString);
    }

    if (!accountObj) {
      processPurl(utmData);
      retrieveAccount(utmData)
        .then((account) => {
          if (!account.accountProducts.length) {
            account.accountProducts = Products();
          }
          setSessionStorageItemWithExpiration(SESSION_STORAGE_ACCOUNT_KEY, account, 60);
          if (!account.accountOverrides) {
            setColorsFromAccount(account.account);
          } else {
            setColorsFromAccount(account.accountOverrides[0]);
          }
          setSaveQuoteData();
          setEmailCapture(account.account);
          redirectUtm(account);
          setLoadingSite(false);
        })
        .catch((error) => {
          setError(true);
          setLoadingSite(false);
          return;
        });
    } else {
      if (!accountObj.accountOverrides) {
        setColorsFromAccount(accountObj.account);
      } else {
        setColorsFromAccount(accountObj.accountOverrides[0]);
      }
      setSaveQuoteData();
      setEmailCapture(accountObj.account);
      redirectUtm(accountObj);
      setLoadingSite(false);
    }
    
    if (window.location.href.includes("DataImport")) {
      setLoadingClientInfo(true);
      loadClientInfo().then((clientInfo) => {
        if (clientInfo !== undefined) {
          setSessionStorageItemWithExpiration(SESSION_STORAGE_CLIENTINFO_KEY, clientInfo, 60);
        }
        setLoadingClientInfo(false);
      }).catch((error) => {
        setLoadingClientInfo(false);
      });
    }
    else {
      setLoadingClientInfo(false)
    }
  }, []);

  if (isIe) {
    return (
      <div>
        <NoIeSupport />
      </div>
    );
  }
  return (
    <div>
      {loadingSite === false && loadingClientInfo === false && error === false && (
        <ThemeProvider theme={Theme.get(primaryColor, secondaryColor)}>
          <Router>
            <Layout>
              <Switch>
                <Route exact path="/" render={(props) => <Home {...props} />} />

                <Route path="/RetrieveProgress" component={RetrieveProgress} />

                <Route path="/Portal" component={Portal} />

                <Route path="/landing/:product" component={ProductLandingPage} />

                <Route path="/gl" component={Gerber} />

                <Route path="/select-appointment" component={AppointmentScheduler} />
                <Route path="/select-appointment/:path" component={AppointmentScheduler} />

                <Route path="/quote/term-life-insurance/multi-carrier-term" component={MCT} />
                <Route path="/quote/term-life-insurance/multi-carrier-term/:path" component={MCT} />

                <Route path="/whole-life" component={WholeLife} />
                <Route path="/whole-life/:path" component={WholeLife} />

                <Route path="/universal-life" component={UniversalLife} />
                <Route path="/universal-life/:path" component={UniversalLife} />

                <Route path="/term-insurance" component={CustomizeTerm} />
                <Route path="/term-insurance/:path" component={CustomizeTerm} />

                <Route path="/final-expense" component={FinalExpense} />
                <Route path="/final-expense/:path" component={FinalExpense} />

                <Route path="/loan-protection/EsignReturn" component={EsignReturn} />
                <Route path="/loan-protection/:path" component={LoanProtection} />
                <Route path="/loan-protection" component={LoanProtection} />

                <Route path="/quote/term-life-insurance/fully-digital" component={Digital} />
                <Route path="/quote/term-life-insurance/fully-digital/:path" component={Digital} />

                <Route path="/quote/term-life-insurance/loan-protector/EsignReturn" component={EsignReturn} />
                <Route path="/quote/term-life-insurance/loan-protector/:path" component={Americo} />
                <Route path="/quote/term-life-insurance/loan-protector" component={Americo} />

                <Route path="/quote/term-life-insurance/:path" component={MCT} />

                <Route path="/quote/whole-life/securian-secure-promise/EsignReturn" component={EsignReturn} />
                <Route path="/quote/whole-life/securian-secure-promise/:path" component={SecurianWL} />
                <Route path="/quote/whole-life/securian-secure-promise" component={SecurianWL} />

                <Route path="/quote/long-term-care" component={LTC} />
                <Route path="/quote/disability/ameritas-dinamic-Fundamental/:path" component={Ameritas} />
                <Route path="/quote/disability/ameritas-dinamic-Fundamental/" component={Ameritas} />
                <Route path="/quote/disability/long-term/:path" component={LongTerm} />
                <Route path="/quote/disability/long-term/" component={LongTerm} />
                <Route path="/quote/term-health-insurance/medicare/:path" component={Medicare} />
                <Route path="/quote/term-health-insurance/medicare/" component={Medicare} />
                <Route path="/quote/supplemental/:path" component={Supplemental} />

                <Route path="/quote/aflac/hospital-confinement/EsignReturn" component={EsignReturn} />
                <Route path="/quote/aflac/hospital-confinement/:path" component={Aflac} />
                <Route path="/quote/aflac/hospital-confinement/" component={Aflac} />

                <Route path="/Ineligible" component={Ineligible} />
                <Route path="/StateDisclosure" component={StateDisclosure} />
                <Route path="/DidNotConsent" component={DidNotConsent} />

                <Route path="/tools/budget-based-quoter" component={BudgetBasedQuoter} />

                <Route path="/status" component={Status} />
                <Route path="/Action/Status" component={Status} />
                <Route path="/Action/SignNow" component={Status} />

                <Route path="/account/:path/:applicationId" component={Account} />
                <Route path="/account/:path" component={Account} />

                <Route path="/policy-review" component={Landing} exact />
                <Route path="/policy-review/existing-insurance" component={ExistingInsurance} />
                <Route path="/policy-review/schedule" component={Schedule} />
                <Route path="/policy-review/summary" component={Summary} />

                <Route path="/partner-referral" component={PartnerReferral} />

                <Route path="/ns" component={NewSession} />
                <Route path="*" component={PageNotFound} />
                
              </Switch>
            </Layout>
          </Router>
        </ThemeProvider>
      )}

      {loadingSite && (
        <div className="d-flex justify-content-center mt-4">
          <CircularProgress />
        </div>
      )}

      {error && (
        <div className="d-flex justify-content-center mt-4">
          <p>The account you are trying to access does not exist. Please check the URL and try again.</p>
        </div>
      )}
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js